// CommonJS keeps Next config, Edge middleware and sitemap on the same policy.
const policy = require('./locales.json');
const CORE_SUPPORTED_LOCALES = Object.freeze(Object.keys(policy.locales));
const CORE_DEFAULT_LOCALE = policy.defaultLocale;
const CORE_FALLBACK_LOCALE = policy.fallbackLocale;

// core 는 지역코드 없는 언어만 지원한다(ko/en/ja/es/ms/th) — 앞자리만 보면 된다.
// 지원 목록이 정확 일치 허용목록이라 이상한 입력은 여기서 undefined 로 떨어진다.
function toSupportedLanguage(value) {
  if (typeof value !== 'string') return undefined;
  // replaceAll 은 Chrome 85+ 라 구형 안드로이드 크롬에서 터졌다 (WEB-APP-24R).
  const language = value.trim().toLowerCase().replace(/_/g, '-').split('-')[0];
  return CORE_SUPPORTED_LOCALES.includes(language) ? language : undefined;
}

function resolveCoreLocale(value) {
  return toSupportedLanguage(value) ?? CORE_FALLBACK_LOCALE;
}

// Accept-Language 한 항목: "ja-JP;foo=1;q=0.8" → { language: 'ja-JP', quality: 0.8 }
function parseLanguageTag(tag) {
  const [language, ...parameters] = tag.split(';');
  const q = parameters.find(parameter => parameter.trim().startsWith('q='));
  return {
    language: language.trim(),
    // RFC 9110: q 는 0~1. NaN·Infinity 는 아래 범위 비교에서 함께 걸러진다.
    quality: q === undefined ? 1 : Number(q.trim().slice('q='.length)),
  };
}

function detectCoreLocale(cookie, acceptLanguage) {
  // 쿠키는 정확히 지원하는 값만 신뢰한다. 오래된/미지원 값은 무시.
  if (CORE_SUPPORTED_LOCALES.includes(cookie)) return cookie;
  const tags = (acceptLanguage || '')
    .split(',')
    .map(parseLanguageTag)
    .filter(
      ({ language, quality }) => language !== '' && quality > 0 && quality <= 1,
    )
    // sort 는 안정적이라 q 가 같으면 헤더에 적힌 순서가 유지된다.
    .sort((a, b) => b.quality - a.quality);
  for (const { language } of tags) {
    const supported = toSupportedLanguage(language);
    if (supported) return supported;
  }
  return CORE_FALLBACK_LOCALE;
}

module.exports = {
  CORE_SUPPORTED_LOCALES,
  CORE_DEFAULT_LOCALE,
  CORE_FALLBACK_LOCALE,
  resolveCoreLocale,
  detectCoreLocale,
};
